/* Loop 2 R5: quote list handoff (snippets/quote-drawer.liquid toolbar [data-imm-qshare]). Loaded after assets/imm.js.
   Share link: ?ql=<handle>*<qty>,... (free-text lines as ~<text>*<qty>), only product handles and quantities, no
   personal data; capped at ~1800 characters. The recipient sees "Load this list" and the lines are looked up via
   same-origin /products/<handle>.js. Also: WhatsApp (wa.me/?text=, buyer picks the contact), mailto to a colleague,
   CSV download. Items live in localStorage imm_quote (same shape as R3). No analytics events are published here. */
(function () {
  var KEY = 'imm_quote', MAXURL = 1800, MAXLOAD = 40;
  var qd = document.querySelector('[data-imm-qd]');
  if (!qd) return;
  var bar = qd.querySelector('[data-imm-qshare]'), list = qd.querySelector('[data-imm-qlist]');

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} if (window.immQuoteRender) window.immQuoteRender(); }
  function say(m) { if (window.immToast) window.immToast(m); }
  function handle(u) { var m = /\/products\/([^/?#]+)/.exec(u || ''); return m ? m[1] : ''; }

  function shareUrl(a) {
    var parts = [], used = 0, base = location.origin + '/?ql=';
    for (var i = 0; i < a.length; i++) {
      var it = a[i], h = handle(it.u);
      var tok = (h ? h : '~' + encodeURIComponent(String(it.t || '').slice(0, 60)).replace(/[,*]/g, function (c) { return encodeURIComponent(c); })) + '*' + (it.q || 1);
      if ((base + parts.concat(tok).join(',')).length > MAXURL) break;
      parts.push(tok); used++;
    }
    return { url: base + parts.join(','), used: used, total: a.length };
  }
  function lines(a) {
    return a.map(function (it, i) {
      return (i + 1) + '. ' + (it.q || 1) + ' x ' + it.t + (it.v && it.u ? ' (' + it.v + ')' : '') + (it.p ? ', list $' + it.p : '') + (it.u ? '' : ', part number') + (it.n ? ' (note: ' + it.n + ')' : '');
    }).join('\n');
  }
  function textFor(a, s) {
    return 'Quote list from IndoMultiMeter (' + a.length + ' line' + (a.length === 1 ? '' : 's') + '):\n' + lines(a) +
      '\n\nOpen the list: ' + s.url + (s.used < s.total ? '\n(the link holds the first ' + s.used + ' lines)' : '');
  }
  function csv(a) {
    function c(v) {
      v = String(v == null ? '' : v);
      if (/^[=+\-@\t\r]/.test(v)) v = "'" + v;   // no spreadsheet formulas from list text
      return /[",\n\r;]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v;
    }
    window.immCsvCell = c;
    var rows = [['Line', 'Qty', 'Brand', 'Product', 'List price (USD)', 'URL', 'Note']];
    a.forEach(function (it, i) { rows.push([i + 1, it.q || 1, it.u ? it.v : '', it.t, it.p || '', it.u ? location.origin + it.u : 'not in online catalogue', it.n || '']); });
    return '﻿' + rows.map(function (r) { return r.map(c).join(','); }).join('\r\n');
  }
  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (res, rej) {
      var t = document.createElement('textarea'); t.value = text; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy') ? res() : rej(); } catch (e) { rej(e); }
      document.body.removeChild(t);
    });
  }

  if (bar) {
    var sync = function () { bar.hidden = load().length === 0; };
    if (list && 'MutationObserver' in window) new MutationObserver(sync).observe(list, { childList: true });
    sync();
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qs]'); if (!b) return;
      var a = load(); if (!a.length) return;
      var s = shareUrl(a), act = b.getAttribute('data-qs');
      if (act === 'link') {
        copy(s.url).then(function () { say('Share link copied' + (s.used < s.total ? ' (first ' + s.used + ' of ' + s.total + ' lines)' : '') + '. Anyone with the link can load this list.'); },
          function () { window.prompt('Copy this link:', s.url); });
      } else if (act === 'wa') {
        window.open('https://wa.me/?text=' + encodeURIComponent(textFor(a, s)), '_blank', 'noopener');
      } else if (act === 'mail') {
        var body = textFor(a, s); if (body.length > 1800) body = body.slice(0, 1700) + '\n...\nOpen the list: ' + s.url;
        location.href = 'mailto:?subject=' + encodeURIComponent('Quote list: ' + a.length + ' instrument line' + (a.length === 1 ? '' : 's')) + '&body=' + encodeURIComponent(body);
      } else if (act === 'csv') {
        var blob = new Blob([csv(a)], { type: 'text/csv;charset=utf-8' }), u = URL.createObjectURL(blob), l = document.createElement('a');
        l.href = u; l.download = 'quote-list-' + new Date().toISOString().slice(0, 10) + '.csv';
        document.body.appendChild(l); l.click(); document.body.removeChild(l);
        setTimeout(function () { URL.revokeObjectURL(u); }, 1500);
      }
    });
  }

  /* recipient side: ?ql=... */
  // raw ql (not URLSearchParams, which decodes %2C before the split); each token decoded once, malformed ones skipped
  function parseQl(search) {
    var mm = /[?&]ql=([^&#]*)/.exec(search || '');
    if (!mm) return [];
    return mm[1].split(',').slice(0, MAXLOAD).map(function (tok) {
      var m = /^(.*)\*(\d{1,4})$/.exec(tok), body = m ? m[1] : tok, q = m ? Math.max(1, Math.min(9999, +m[2])) : 1;
      try { body = decodeURIComponent(body.replace(/\+/g, ' ')); } catch (e) { return null; }
      if (body.charAt(0) === '~') { var t = body.slice(1).trim(); return t ? { t: t.slice(0, 80), q: q } : null; }
      return /^[a-z0-9][a-z0-9-]{0,200}$/i.test(body) ? { h: body.toLowerCase(), q: q } : null;
    }).filter(Boolean);
  }
  window.immParseQl = parseQl;
  var incoming = parseQl(location.search);
  if (!incoming.length) return;

  var box = document.createElement('section');
  box.className = 'imm-qs-in'; box.setAttribute('role', 'region'); box.setAttribute('aria-label', 'Shared quote list');
  box.innerHTML = '<div class="imm-wrap imm-qs-in__wrap"><p class="imm-qs-in__t"><b>Someone shared a quote list with you</b> &middot; ' + incoming.length + ' line' + (incoming.length === 1 ? '' : 's') +
    '</p><div class="imm-qs-in__acts"><button type="button" class="imm-btn imm-btn--primary imm-btn--sm" data-qs-load>Load this list</button>' +
    '<button type="button" class="imm-btn imm-btn--ghost imm-btn--sm" data-qs-no>Dismiss</button></div></div>';
  var main = document.getElementById('MainContent') || document.body;
  main.insertBefore(box, main.firstChild);
  function cleanUrl() { try { var u = new URL(location.href); u.searchParams.delete('ql'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) {} }
  box.addEventListener('click', function (e) {
    if (e.target.closest('[data-qs-no]')) { box.remove(); cleanUrl(); return; }
    var go = e.target.closest('[data-qs-load]'); if (!go) return;
    go.disabled = true; go.textContent = 'Loading…';
    Promise.all(incoming.map(function (x) {
      if (!x.h) return Promise.resolve({ t: x.t, u: '', i: '', v: 'Not in online catalogue', p: '', q: x.q });
      return fetch('/products/' + x.h + '.js', { credentials: 'same-origin' }).then(function (r) {
        if (r.status === 404) return null;
        if (!r.ok) throw new Error(r.status);
        return r.json();
      }).then(function (p) {
        if (!p) return null;
        var v = (p.variants || [])[0] || {};
        var img = p.featured_image ? String(p.featured_image).replace(/^https?:/, '') : '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        return { t: p.title, u: '/products/' + p.handle, i: img, v: p.vendor, p: (Number(v.price != null ? v.price : p.price) / 100).toFixed(2), q: x.q };
      }).catch(function () { return { err: 1 }; });
    })).then(function (got) {
      var a = load(), added = 0, missing = 0, failed = 0;
      got.forEach(function (it) {
        if (!it) { missing++; return; }
        if (it.err) { failed++; return; }
        var ex = null;
        for (var k = 0; k < a.length; k++) if (a[k].u === it.u && (it.u || a[k].t === it.t)) ex = a[k];
        if (ex) ex.q = Math.max(ex.q || 1, it.q); else a.push(it);
        added++;
      });
      save(a); cleanUrl(); box.remove();
      say(added + ' line' + (added === 1 ? '' : 's') + ' loaded' + (missing ? ', ' + missing + ' no longer online' : '') + (failed ? ', ' + failed + ' could not load, open the link again to retry' : '') + ' &middot; <button type="button" data-imm-qopen>View list (' + a.length + ')</button>');
      var o = document.querySelector('[data-imm-qopen]'); if (o) o.click();
    });
  });
})();
